// extracted by mini-css-extract-plugin
module.exports = {"root":"styles-module--root--3-mR1","button":"styles-module--button--2wQzD","animated":"styles-module--animated--2gikm","slideInDown":"styles-module--slideInDown--3zu01"};